<template>
  <div>
    <div class="min-vh-100">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col xl="5" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">รายการคำสั่งซื้อ</h1>
        </b-col>
        <b-col xl="7" class="text-right d-flex justify-content-end">
          <b-input-group class="panel-input-serach">
            <b-form-input
              id="product-search"
              class="input-serach"
              placeholder="ค้นหาหมายเลขคำสั่งซื้อ"
              @keypress="handlePushMessage"
              v-model="filter.search"
            ></b-form-input>
            <b-input-group-prepend>
              <span class="icon-input m-auto pr-2">
                <font-awesome-icon
                  icon="search"
                  title="View"
                  @click="onSubmitFilter"
                />
              </span>
            </b-input-group-prepend>
          </b-input-group>
          <b-button
            class="purple-btn ml-2"
            @click="confirmOrder(null)"
            v-if="tabCurrent == 3"
          >
            <span class="d-none d-sm-inline">ยืนยันคำสั่งซื้อ</span>
          </b-button>
          <b-button
            class="purple-btn ml-2"
            @click="onContinueTransaction(null)"
            v-if="tabCurrent == 13"
          >
            <span class="d-none d-sm-inline">ย้ายรายการที่เลือก</span>
          </b-button>
          <b-dropdown
            id="dropdown-product"
            text="ตัวเลือกเพิ่มเติม"
            class="ml-2 dropdown-option"
          >
            <!-- <b-dropdown-item>สร้างรายการสินค้าใหม่</b-dropdown-item> -->
            <b-dropdown-item
              v-if="tabCurrent == 4"
              @click="onSendPauseTransaction"
              >พักรายการ</b-dropdown-item
            >
            <b-dropdown-item
              v-if="tabCurrent == 13"
              @click="onSendContinueTransaction"
              >ดำเนินรายการต่อ</b-dropdown-item
            >
            <b-dropdown-item>นำออกข้อมูล</b-dropdown-item>
            <!-- <b-dropdown-item>ดาวน์โหลดใบกำกับภาษี</b-dropdown-item>
            <b-dropdown-item>ดาวน์โหลดบิลอย่างย่อ</b-dropdown-item> -->
          </b-dropdown>
          <b-button v-b-toggle.sidebar-filter class="btn-filter ml-2">
            <font-awesome-icon
              icon="filter"
              title="filter-btn"
              class="main-color mr-0 mr-sm-1"
            />
            <span class="d-none d-sm-inline">ตัวกรอง </span>
          </b-button>
        </b-col>
      </CRow>
      <b-sidebar
        id="sidebar-filter"
        backdrop
        shadow
        backdrop-variant="dark"
        right
        ref="filterSidebar"
        aria-labelledby="sidebar-filter-title"
        no-header
      >
        <template #default="{ hide }">
          <div class="p-3 sidebar-filter-header d-flex justify-content-between">
            <h4 id="sidebar-filter-title" class="m-0">ตัวกรอง</h4>
            <font-awesome-icon
              class="my-auto"
              icon="times-circle"
              color="#FFFFFF"
              @click="hide"
            />
          </div>
          <div class="px-3 py-2">
            <div class="mt-2">
              <b-input-group class="panel-input-serach">
                <b-form-input
                  id="product-search"
                  class="input-serach"
                  placeholder="ค้นหาหมายเลขคำสั่งซื้อ"
                  v-model="filter.search"
                ></b-form-input>
                <b-input-group-prepend>
                  <span class="icon-input m-auto pr-2">
                    <font-awesome-icon icon="search" title="View" />
                  </span>
                </b-input-group-prepend>
              </b-input-group>
            </div>

            <div class="mt-3">
              <div class="font-weight-bold mb-2">วันที่ทำรายการ (เริ่มต้น)</div>
              <div :class="['input-container']">
                <!-- <div
              :class="['input-container', { error: $v.form.startDate.$error }]"
            > -->
                <datetime
                  :input-style="styleDatetime"
                  v-model="filter.startDate"
                  placeholder="วว / ดด / ปป"
                  ref="startDate"
                >
                </datetime>
                <div
                  class="icon-container text-right"
                  @click="$refs.startDate.isOpen = true"
                >
                  <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
                </div>
              </div>
            </div>

            <div class="mt-3">
              <div class="font-weight-bold mb-2">วันที่ทำรายการ (สิ้นสุด)</div>
              <div :class="['input-container']">
                <!-- <div
              :class="['input-container', { error: $v.form.startDate.$error }]"
            > -->
                <datetime
                  :input-style="styleDatetime"
                  v-model="filter.endDate"
                  placeholder="วว / ดด / ปป"
                  ref="endDate"
                >
                </datetime>
                <div
                  class="icon-container text-right"
                  @click="$refs.endDate.isOpen = true"
                >
                  <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
                </div>
              </div>
            </div>

            <div class="mt-3">
              <div class="font-weight-bold mb-2">ช่องทางการซื้อ</div>
              <b-form-group>
                <div class="d-flex flex-row flex-wrap">
                  <b-form-checkbox
                    v-for="(channel, index) in saleChannelConfigList"
                    :key="index"
                    :value="channel.id"
                    class="mb-2 w-50"
                    v-model="filter.channel"
                    >{{ channel.salesChannal }}</b-form-checkbox
                  >
                </div>
              </b-form-group>
            </div>

            <div class="mt-3">
              <div class="font-weight-bold mb-2">สถานะรายการ</div>
              <b-form-group>
                <b-form-checkbox
                  v-for="(status, index) in orderStatusConfigList"
                  :key="index"
                  :value="status.orderStatusId"
                  class="mb-2"
                  v-model="filter.orderStatus"
                  >{{ status.name }}</b-form-checkbox
                >
              </b-form-group>
            </div>

            <div class="mt-3">
              <div class="font-weight-bold mb-2">ความเร่งด่วน</div>
              <b-form-group>
                <b-form-checkbox
                  v-for="(movement, index) in orderMovementTimeStatusConfigList"
                  :key="index"
                  :value="movement.id"
                  class="mb-2"
                  v-model="filter.orderMovement"
                  >{{ movement.name }}</b-form-checkbox
                >
              </b-form-group>
            </div>

            <div class="mt-3">
              <div class="font-weight-bold mb-2">ช่องทางการชำระเงิน</div>
              <b-form-group>
                <b-form-checkbox
                  v-for="(type, index) in paymentTypeConfigList"
                  :key="index"
                  :value="type.paymentTypeId"
                  class="mb-2"
                  v-model="filter.paymentType"
                  >{{ type.name }}</b-form-checkbox
                >
              </b-form-group>
            </div>

            <div class="mt-3">
              <div class="font-weight-bold mb-2">โปรโมชัน</div>
              <b-form-group>
                <b-form-checkbox
                  v-for="(promotion, index) in promotionConfigList"
                  :key="index"
                  :value="promotion.id"
                  class="mb-2"
                  v-model="filter.promotion"
                  >{{ promotion.name }}</b-form-checkbox
                >
              </b-form-group>
            </div>
          </div>
        </template>

        <template #footer>
          <div
            class="
              d-flex
              justify-content-between
              shadow
              align-items-center
              border-top
            "
          >
            <div class="w-100">
              <b-button
                block
                size="lg"
                variant="light"
                class="text-dark w-100 border-radius-0 btn-clear-filter"
                @click="clearFilter"
                >ล้างตัวกรอง</b-button
              >
            </div>
            <div class="w-100">
              <b-button
                block
                size="lg"
                variant="light"
                class="text-body btn-main w-100 border-radius-0"
                @click="onSubmitFilter"
              >
                ยืนยัน
              </b-button>
            </div>
          </div>
        </template>
      </b-sidebar>
      <b-row class="no-gutters px-3 px-sm-0 mt-2">
        <b-col class="overflow-auto">
          <b-tabs class="mt-2 order-tabs">
            <b-tab
              v-for="(item, index) in statusList"
              :key="index"
              :title="item.name + ' (' + item.count + ')'"
              :active="isActive(item.orderStatusId)"
              @click="selectTab(item.orderStatusId)"
            >
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
      <div class="bg-white py-3 py-sm-0">
        <b-row class="no-gutters px-3 px-sm-0">
          <b-col>
            <b-table
              responsive
              class="text-center table-list mb-0"
              striped
              :fields="fields"
              :items="items"
              :busy="isBusy"
              show-empty
              empty-text="ไม่พบข้อมูล"
            >
              <template v-slot:head(id)="">
                <b-form-checkbox
                  size="lg"
                  class="ml-3"
                  id="order-time-cb-all"
                  name="orderTimeCbAll"
                  v-model="orderTimeAll"
                  @change="checkOrderHeader"
                ></b-form-checkbox>
              </template>

              <template v-slot:cell(productQty)="data">
                <div class="stock-text" v-if="data.item.productQty">
                  <p class="m-0">{{ data.item.productQty | numeral("0,0") }}</p>
                </div>
                <div v-else class="stock-text"><p class="m-0">-</p></div>
              </template>
              <template v-slot:cell(systemInvoiceNo)="data">
                <p class="m-0" v-if="data.item.systemInvoiceNo">
                  {{ data.item.systemInvoiceNo }}
                </p>
                <p v-else class="m-0">-</p>
              </template>

              <template v-slot:cell(invoiceNo)="data">
                <div v-if="data.item.invoiceNo">
                  <p class="m-0">{{ data.item.invoiceNo }}</p>
                  <b-badge
                    v-if="data.item.gwp == 1"
                    pill
                    variant="Info"
                    class="px-3 py-2 GWP mt-1"
                    >GWP</b-badge
                  >
                </div>
                <div v-else><p class="m-0">-</p></div>
              </template>

              <template v-slot:cell(receiptNo)="data">
                <p class="m-0" v-if="data.item.receiptNo">
                  {{ data.item.receiptNo }}
                </p>
                <p v-else class="m-0">-</p>
              </template>

              <template v-slot:cell(grandTotal)="data">
                <p class="m-0 price-text" v-if="data.item.grandTotal">
                  ฿ {{ data.item.grandTotal | numeral("0,0.00") }}
                </p>
                <p v-else class="m-0 price-text">-</p>
              </template>

              <template v-slot:cell(paymentType)="data">
                <p class="m-0" v-if="data.item.paymentType">
                  {{ data.item.paymentType }}
                </p>
                <p v-else class="m-0">-</p>
              </template>

              <template v-slot:cell(orderStatus)="data">
                <p class="m-0" v-if="data.item.orderStatus">
                  {{ data.item.orderStatus }}
                </p>
                <p v-else class="m-0">-</p>
              </template>

              <template v-slot:cell(shippingType)="data">
                <p class="m-0" v-if="data.item.shippingType">
                  {{ data.item.shippingType }}
                </p>
                <p v-else class="m-0">-</p>
              </template>
              <template v-slot:cell(salesChannel)="data">
                <div class="position-relative picture-text">
                  <div
                    v-if="data.item.pictureUrl"
                    class="pictureUrl-square-box b-contain"
                    v-bind:style="{
                      'background-image': 'url(' + data.item.pictureUrl + ')',
                    }"
                  ></div>
                  <div v-else-if="data.item.salesChannel" class="">
                    {{ data.item.salesChannel }}
                  </div>
                  <div v-else class="">-</div>
                </div>
              </template>

              <template v-slot:cell(display)="data">
                <div v-if="data.item.display == true" class="">แสดง</div>
                <div v-else class="">ไม่แสดง</div>
              </template>
              <template v-slot:cell(enabled)="data">
                <div>
                  <toggle-button
                    class="mt-1 mr-2"
                    v-model="data.item.enabled"
                    :color="{
                      checked: '#27BDA7',
                      unchecked: '#F1F1F1',
                      disabled: '#CCCCCC',
                    }"
                  />
                </div>
              </template>
              <template v-slot:cell(id)="data">
                <b-form-checkbox
                  size="lg"
                  class="ml-3"
                  :value="data.item.orderId"
                  v-model="itemsSelected"
                ></b-form-checkbox>
              </template>
              <template v-slot:cell(createdTime)="data">
                <div class="date-cb" v-if="data.item.createdTime">
                  {{
                    new Date(data.item.createdTime) | moment($formatDateTime)
                  }}
                </div>
                <div class="date-cb" v-else><p class="m-0">-</p></div>
              </template>
              <template v-slot:cell(paymentTime)="data">
                <div class="date-text" v-if="data.item.paymentTime">
                  <font-awesome-icon
                    icon="circle"
                    :class="[
                      'flag',
                      data.item.orderMovementTimeFlag === 'Danger'
                        ? 'text-danger'
                        : data.item.orderMovementTimeFlag === 'Success'
                        ? 'text-success'
                        : 'text-warning',
                    ]"
                  />
                  {{
                    new Date(data.item.paymentTime) | moment($formatDateTime)
                  }}
                </div>
                <div class="date-text" v-else><p class="m-0">-</p></div>
              </template>
              <template v-slot:cell(updatedTime)="data">
                <div class="date-text" v-if="data.item.updatedTime">
                  {{
                    new Date(data.item.updatedTime) | moment($formatDateTime)
                  }}
                </div>
                <div class="date-text" v-else>-</div>
              </template>
              <template v-slot:cell(orderId)="data">
                <b-button variant="link" class="px-1 py-0">
                  <router-link
                    :to="
                      '/order/details/' +
                      data.item.orderId +
                      '?brandID=' +
                      $route.query.brandID
                    "
                    class="text-purple-1"
                  >
                    <u>ดูรายละเอียด</u>
                  </router-link> </b-button
                ><br />
                <!-- <span
                  class="modal-link text-purple-1"
                  @click="confirmOrder(data.item.orderId)"
                  v-if="tabCurrent == 3"
                >
                  ยืนยันคำสั่งซื้อ<br />
                </span> -->

                <span
                  class="modal-link text-purple-1"
                  v-if="tabCurrent == 4 && itemsSelected.length <= 1"
                  @click="onPauseTransaction(data.item.orderId)"
                >
                  พักรายการ<br />
                </span>
                <span
                  class="modal-link text-purple-1"
                  v-if="tabCurrent == 13 && itemsSelected.length <= 1"
                  @click="onContinueTransaction(data.item.orderId)"
                >
                  ย้ายกลับไปรอยืนยัน<br />
                </span>
                <span
                  class="modal-link text-purple-1"
                  v-if="tabCurrent == 14 && data.item.paymentType == 'Transfer'"
                >
                  พิมพ์ใบปะหน้า<br />
                </span>
                <span
                  class="modal-link text-purple-1"
                  v-if="tabCurrent == 3"
                  @click="onGetPaymentDetail(data.item)"
                >
                  หลักฐานการโอน<br />
                </span>
              </template>
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row class="no-gutters px-3 px-sm-0" v-show="!isBusy">
          <b-col
            class="form-inline justify-content-center justify-content-sm-end"
          >
            <div class="d-sm-flex m-3">
              <b-pagination
                v-model="filter.pageNo"
                :total-rows="rows"
                :per-page="filter.perPage"
                class="m-md-0 page-item"
                @change="pagination"
                align="center"
              ></b-pagination>
            </div>

            <b-form-select
              class="mr-sm-3 select-page"
              v-model="filter.perPage"
              @change="hanndleChangePerpage"
              :options="pageOptions"
            ></b-form-select>
          </b-col>
        </b-row>
      </div>
    </div>
    <ModalPaymentDetail
      ref="modalPaymentDetail"
      :orderId="orderSelected.orderId"
      :invoiceNo="orderSelected.invoiceNo"
      :orderTotalAmount="orderSelected.grandTotal"
      :isCanEdit="true"
      v-on:onRefreshData="hadleModalAlertClose"
    />
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import orderJson from "@/assets/mockdata/order/OrderList.json";
import orderSimple from "@/assets/mockdata/order/OrderSimple.json";
import InputSelect from "@/components/inputs/InputSelect";
import Checkbox from "@/components/inputs/InputCheckBox";
import ModalPaymentDetail from "./components/modal/ModalPaymentDetail.vue";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  name: "OrderIndex",
  components: {
    InputSelect,
    Checkbox,
    ModalPaymentDetail,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
  },
  data() {
    return {
      modalMessage: "",
      orderSelected: {
        orderId: 0,
        invoiceNo: "",
        grandTotal: 0,
      },
      fields: [
        { key: "id", label: "" },
        {
          key: "createdTime",
          label: `วันที่สั่งซื้อ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "paymentTime",
          label: `วันที่ชำระเงิน`,
          class: "w-100px text-nowrap",
        },
        {
          key: "systemInvoiceNo",
          label: `หมายเลขคำสั่งซื้อระบบ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "invoiceNo",
          label: `หมายเลขคำสั่งซื้อ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "receiptNo",
          label: `หมายเลขบิล`,
          class: "w-100px text-nowrap",
        },
        {
          key: "productQty",
          label: `จำนวนชิ้น`,
          class: "w-100px text-nowrap",
        },
        {
          key: "grandTotal",
          label: `ยอดสุทธิ`,
          class: "w-50px text-nowrap",
        },
        {
          key: "paymentType",
          label: `ช่องทางการชำระเงิน`,
          class: "w-100px text-nowrap",
        },
        {
          key: "shippingType",
          label: `ช่องทางการจัดส่ง / หมายเลขพัสดุ`,
          class: "w-100px text-nowrap",
        },
        {
          key: "orderStatus",
          label: `สถานะคำสั่งซื้อ`,
          class: "w-200px text-nowrap",
        },
        {
          key: "salesChannel",
          label: `ช่องทาง`,
          class: "w-100px text-nowrap",
        },
        {
          key: "updatedTime",
          label: `อัพเดทล่าสุด`,
          class: "w-100px text-nowrap",
        },
        { key: "orderId", label: "", class: "w-50px text-nowrap" },
      ],
      items: [],
      itemsSelected: [],
      itemsPayment: [],
      statusList: [],
      activeItem: "",
      isBusy: false,
      orderJson: orderJson,
      orderSimple: orderSimple,
      filter: {
        search: "",
        startDate: "",
        endDate: "",
        channel: [],
        orderStatus: [],
        orderMovement: [],
        paymentType: [],
        promotion: [],
        perPage: 10,
        pageNo: 1,
      },
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      startPage: 1,
      endPage: 10,
      saleChannelConfigList: [],
      orderStatusConfigList: [],
      orderMovementTimeStatusConfigList: [],
      paymentTypeConfigList: [],
      promotionConfigList: [],
      orderTimeAll: false,
      totalCount: 0,
      listAllDataId: [],
      isPaymentDetailShow: false,
      tabCurrent: 0,
      filterOrderList: {
        startDate: "",
        endDate: "",
        salesChannel: [],
        orderStatus: [],
        orderMovementTime: [],
        paymentType: [],
        promotion: [],
        page: 1,
        pageSize: 10,
        search: "",
      },
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      listTransactionId: [],
      titleModal: "",
      detailModal: "",
      productIdSelectList: [],
      actionType: 0,
    };
  },
  created: async function () {
    this.getStatusList();
    this.getListFilter();
    await this.getFilter();
    await this.getOrderList();
  },
  methods: {
    getFilter(){
      if(this.$route.query.search){
        this.filter.search = this.$route.query.search;
        this.filterOrderList.search = this.filter.search;
      }
      if(this.$route.query.startDate){
        this.filter.startDate = this.$route.query.startDate;
        this.filterOrderList.startDate = new Date(this.filter.startDate);
      }
      if(this.$route.query.endDate){
        this.filter.endDate = this.$route.query.endDate;
        this.filterOrderList.endDate = new Date(this.filter.endDate);
      }
      if(this.$route.query.salesChannel){
        this.filter.channel = this.$route.query.salesChannel.split(",").map(Number);
        this.filterOrderList.salesChannel = this.filter.channel;
      }
      if(this.$route.query.orderStatus){
        this.filter.orderStatus = this.$route.query.orderStatus.split(",").map(Number);
        this.filterOrderList.orderStatus = this.filter.orderStatus;
      }
      if(this.$route.query.orderMovementTime){
        this.filter.orderMovement = this.$route.query.orderMovementTime.split(",").map(Number);
        this.filterOrderList.orderMovementTime = this.filter.orderMovement;
      }
      if(this.$route.query.paymentType){
        this.filter.paymentType = this.$route.query.paymentType.split(",").map(Number);
        this.filterOrderList.paymentType = this.filter.paymentType;
      }
      if(this.$route.query.promotion){
        this.filter.promotion = this.$route.query.promotion.split(",").map(Number);
        this.filterOrderList.promotion = this.filter.promotion;
      }
      if(this.$route.query.pageNo){
        this.filter.pageNo = parseInt(this.$route.query.pageNo) || 1;
        this.filterOrderList.page = this.filter.pageNo;
      }
      if(this.$route.query.perPage){
        this.filter.perPage = parseInt(this.$route.query.perPage) || 10;
        this.filterOrderList.pageSize = this.filter.perPage;
      }

      this.tabCurrent = this.$route.query.tab || 0;
      this.activeItem = this.tabCurrent;
    },
    setFilter(){
      this.$router.push({ path: '/order', 
        query: { 
          brandID: this.$route.query.brandID,
          search : this.filterOrderList.search,
          startDate : this.filter.startDate || "",
          endDate : this.filter.endDate || "",
          salesChannel : this.filterOrderList.salesChannel.toString(),
          orderStatus : this.filterOrderList.orderStatus.toString(),
          orderMovementTime : this.filterOrderList.orderMovementTime.toString(),
          paymentType : this.filterOrderList.paymentType.toString(),
          promotion : this.filterOrderList.promotion.toString(),
          perPage : this.filterOrderList.pageSize ,
          pageNo: this.filterOrderList.page,
          tab: this.tabCurrent
        }
      }).catch(err => {});
    },
    onGetPaymentDetail(orderSelected) {
      this.orderSelected = orderSelected;
      this.$nextTick(() => {
        this.$refs.modalPaymentDetail.show();
      });
    },
    hadleModalAlertClose() {
      this.itemsSelected = [];
      this.filterOrderList.page = 1;
      this.filterOrderList.pageSize = 10;
      this.getOrderList();
      this.getStatusList();
    },
    onPauseTransaction(orderId) {
      this.itemsSelected = [orderId];
      this.onSendPauseTransaction();
    },
    onSendPauseTransaction: async function () {
      if (this.itemsSelected.length > 0) {
        this.$refs.modalLoading.show();
        await this.axios
          .put(`${this.$baseUrl}/transaction/HoldOrder`, {
            ListTransactionId: this.itemsSelected,
          })
          .then((data) => {
            if (data.result == 1) {
              this.modalMessage = "สำเร็จ";
              this.$refs.modalLoading.hide();
              this.$refs.modalAlert.show();
            } else {
              this.modalMessage = data.message;
              this.$refs.modalLoading.hide();
              this.$refs.modalAlertError.show();
            }
          });
      }
    },
    onContinueTransaction(orderId) {
      this.itemsSelected = orderId ? [orderId] : this.itemsSelected;
      this.onSendContinueTransaction();
    },
    onSendContinueTransaction: async function () {
      if (this.itemsSelected.length > 0) {
        this.$refs.modalLoading.show();
        await this.axios
          .put(`${this.$baseUrl}/transaction/RerunOrder`, {
            ListTransactionId: this.itemsSelected,
          })
          .then((data) => {
            if (data.result == 1) {
              this.modalMessage = "สำเร็จ";
              this.$refs.modalLoading.hide();
              this.$refs.modalAlert.show();
            } else {
              this.modalMessage = data.message;
              this.$refs.modalLoading.hide();
              this.$refs.modalAlertError.show();
            }
          });
      }
    },
    pagination (page) {
      this.filter.pageNo = page;
      this.filterOrderList.page = page;
      this.setFilter();
      this.getOrderList();
      this.getStatusList();
    },
    isActive: function (menuItem) {
      return this.activeItem == menuItem;
    },
    getOrderList: async function () {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/order/orderlist`, this.filterOrderList)
        .then((data) => {
          this.rows = data.totalCount;
          this.items = data.data;
          this.totalCount = data.totalCount;
          this.listAllDataId = data.listAllDataId;
          this.isBusy = false;
        });

      this.filter.pageNo = this.filterOrderList.page;
      // this.items = this.orderJson.detail.dataList;
      this.itemsPayment = this.orderSimple;
    },
    getStatusList() {
      this.axios
        .post(`${this.$baseUrl}/order/countorder`, this.filterOrderList)
        .then((data) => {
          console.log(data.detail);
          this.statusList = data.detail;
        });
    },
    getListFilter() {
      this.axios.get(`${this.$baseUrl}/order/`).then((data) => {
        this.saleChannelConfigList = data.detail.saleChannalConfig;
        this.orderStatusConfigList = data.detail.orderStatusConfig;
        this.orderMovementTimeStatusConfigList =
          data.detail.orderMovementTimeStatusConfig;
        this.paymentTypeConfigList = data.detail.getPaymentTypeConfig;
        this.promotionConfigList = data.detail.getPromotionConfig;
      });
    },
    hanndleChangePerpage(value) {
      this.filter.pageNo = 1;
      this.filter.perPage = value;
      this.filterOrderList.page = 1;
      this.filterOrderList.pageSize = value;
      this.setFilter();
      this.getOrderList();
      this.getStatusList();
    },
    checkOrderHeader(value) {
      if (value) {
        this.itemsSelected = this.listAllDataId;
        this.listTransactionId = this.listAllDataId;
      } else {
        this.itemsSelected = [];
        this.listTransactionId = [];
      }
    },
    selectTab(tab) {
      this.tabCurrent = tab;
      if (tab != [0]) {
        this.filterOrderList.orderStatus = [tab];
      } else {
        this.filterOrderList.orderStatus = [];
      }
      this.filterOrderList.page = 1;
      this.filterOrderList.pageSize = 10;
      this.filter.pageNo = 1;
      this.filter.perPage = 10;
      this.setFilter();
      this.clearCheckBox();
      this.getOrderList();
      this.getStatusList();
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.onSubmitFilter();
      }
    },
    onSubmitFilter() {
      this.filterOrderList.promotion = this.filter.promotion;
      this.filterOrderList.paymentType = this.filter.paymentType;
      this.filterOrderList.orderMovementTime = this.filter.orderMovement;
      this.filterOrderList.orderStatus = this.filter.orderStatus;
      this.filterOrderList.salesChannel = this.filter.channel;
      this.filterOrderList.startDate = new Date(this.filter.startDate);
      this.filterOrderList.search = this.filter.search;
      this.filterOrderList.endDate = new Date(this.filter.endDate);
      this.filterOrderList.page = 1;
      this.filter.pageNo = 1;
      this.setFilter();
      this.getOrderList();
      this.getStatusList();
      this.clearCheckBox();
      this.$refs.filterSidebar.hide();
    },
    clearCheckBox() {
      this.itemsSelected = [];
      this.orderTimeAll = false;
    },
    clearFilter: async function () {
      this.filter = {
        search: "",
        startDate: "",
        endDate: "",
        channel: [],
        orderStatus: [],
        orderMovement: [],
        paymentType: [],
        promotion: [],
        perPage: 10,
        pageNo: 1,
      };
      this.filterOrderList = {
        startDate: "",
        endDate: "",
        salesChannel: [],
        orderStatus: [],
        orderMovementTime: [],
        paymentType: [],
        promotion: [],
        page: 1,
        pageSize: 10,
        search: "",
      };
      await this.setFilter();
      this.getOrderList();
      this.getStatusList();
    },
    confirmOrder(id) {},
    reRunOrder(id) {
      this.axios
        .put(`${this.$baseUrl}/transaction/RerunOrder`, {
          ListTransactionId: this.productIdSelectList,
        })
        .then((data) => {
          console.log(`data`, data);
          this.getProductList();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.outofstock {
  background-color: #dc3545;
}
.GWP {
  background-color: #e3e2f2;
  color: #8078c6;
}
.purple-btn {
  background-color: #8a44c3;
  color: #ffffff;
  min-height: 40px;
  min-width: 150px;
  transition: 0.3s;
}
.date-cb {
  width: 120px;
}
.date-text {
  width: 120px;
}
.stock-text {
  min-width: 80px;
}
.price-text {
  white-space: nowrap;
}
.picture-text {
  min-width: 50px;
}
.checkbox-header {
  text-align: left;
}
.modal-link {
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
}
.pictureUrl-square-box {
  margin: auto;
  width: 50%;
  padding-top: 50%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.flag {
  font-size: 14px;
}
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
}
.input-container.error {
  border-color: red !important;
}
</style>
